// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-module--loader--3WLJQ","loaderCircle":"loader-module--loaderCircle--10hbv","loaderPercentage":"loader-module--loaderPercentage--1meCF"};